import * as types from "./types";

export default {
  [types.CSAT_SURVEY]: (state) => state.csatSurvey,
};
